import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../app/hooks";

export const useActiveRoomColoringIdQuerySync = () => {
  const [, setSearchParams] = useSearchParams();
  const activeRoomColoringId = useAppSelector((state) => state.design.activeRoomColoringId);
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const nextValue = activeRoomColoringId?.trim() ?? "";

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const current = (next.get("color") ?? "").trim();

        if (!nextValue) {
          if (!next.has("color")) return prev;
          next.delete("color");
          return next;
        }

        if (current === nextValue) return prev;

        next.set("color", nextValue);
        return next;
      },
      { replace: true }
    );
  }, [activeRoomColoringId, setSearchParams]);
};
